import { render, staticRenderFns } from "./link-divider.vue?vue&type=template&id=2d332d82&scoped=true&"
import script from "./link-divider.vue?vue&type=script&lang=js&"
export * from "./link-divider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d332d82",
  null
  
)

export default component.exports